import { createFileRoute, redirect } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { MOVED_TO_CATALOGUE, tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";

export const Route = createFileRoute("/_authenticated/inventory")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  // Whatever remains is `/inventory`, with nothing after it.
  validateSearch: tabSearch("inventory"),
  beforeLoad: ({ search, context, location }) => {
    // THE THREE IDS THAT LEFT THE SHELF ARE FORWARDED, NOT DRAWN.
    //
    // An alias resolves an old id to a tab this surface still has; `products`,
    // `pricing` and `formulary` name a screen that is `/catalogue`'s now. They
    // reach here as themselves — `resolveTab` passes an id it does not know
    // through on purpose, so a module's tab is not refused before the module
    // exists — and Inventory's answer to an id it does not draw is its own
    // first tab. So without this, `?tab=pricing` renders the shelf: a link that
    // silently went somewhere else, on a screen that looks perfectly fine.
    //
    // `replace`, because an old address is not a step in anybody's history —
    // Back should leave for wherever they actually came from.
    //
    // THE HOP LANDS ON `/catalogue` AND NOTHING AFTER IT. The section a future
    // catalogue screen opens is that screen's memory, the same rule as
    // Settings (`app/module-address.ts`). `?item=` is not on this address:
    // this surface's `validateSearch` models `tab` alone, so zod has already
    // stripped anything else. When the real screen arrives, a product a link
    // named has to be carried in memory, not put back on the address.
    //
    // BEFORE THE PERMISSION CHECK, and it costs nothing today: both surfaces
    // are behind `VIEW_INVENTORY` (see `app/nav.ts`), so a reader who may not
    // open the shelf may not open the catalogue either and meets the same
    // refusal one address along. Were the two rights ever to part, this order
    // would have to reverse — a redirect that outruns a guard is how a door
    // gets opened by being pointed at the room behind it.
    const moved = search.tab === undefined ? undefined : MOVED_TO_CATALOGUE[search.tab];
    if (moved) {
      throw redirect({ to: "/catalogue", search: {}, hash: "", replace: true, ignoreBlocker: true });
    }
    replaceWithBareModule("/inventory", location);
    requirePerm("VIEW_INVENTORY")({ context });
  },
  component: () => <PendingSurface titleKey="nav.inventory" />,
});
